import * as React from "react";
import {ListProductsRequest, ProductView} from "../../../../generated/protocol";
import {PagerModel} from "../../list/PagerModel";
import {UserService} from "../../../service/admin/UserService";
import {EntityDataTable} from "../../list/EntityDataTable";
import {AppCtx} from "../../../ioc/ApplicationContext";
import {ListUtils} from "../../list/ListUtils";
import {RouterView, LoadingViewState} from "../RouterView";
import {ColumnType} from "../../list/ColumnType";
import {ProductService} from "../../../service/admin/ProductService";
import {Symbols} from "../../../ioc/Symbols";


interface State extends LoadingViewState {
    listRequest: ListProductsRequest
}

export class ProductListView extends RouterView<{}, State> {

    columns = [
        {property: "image", name: "Image", orderBy: "image", type: ColumnType.IMAGE},
        {property: "name", name: "Name", orderBy: "name"},
        {property: "description", name: "Description", orderBy: "description"},
        {property: "category", name: "Category", orderBy: "category"},
        {property: "currencyCode", name: "Currency", orderBy: "currencyCode"},
        {property: "price", name: "Price", orderBy: "price"},

    ];
    actions = [
        {id: "view", name: "View", className: "btn btn-primary", iconClassName: "fa fa-eye"}
    ];

    productService: ProductService;
    private readonly activedOperatorId: number = AppCtx.getUserStore().getState().activeOperator;

    constructor(props) {
        super(props);
        this.productService = AppCtx.resolve<UserService>(Symbols.ProductService);
        this.state = {loading: false, listRequest: {operatorId:this.activedOperatorId,
                offset: 0, limit: 50, ascending: true, orderBy: "name"}}
    }

    loadContent(): Promise<any> {
        return undefined;
    }

    pagerChanged(pager: PagerModel) {
        let listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
        this.setState({listRequest: listRequest});
    }

    onAction(item: ProductView, action: string) {
        if (action == "view") {
            this.navigate("/product/" + item.productId);
        }
    }

    getTitle() {
        return "Products";
    }

    renderContent() {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>{this.getTitle()}</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated fadeInRight">

                    <EntityDataTable service={this.productService} onPagerChange={this.pagerChanged.bind(this)}
                                     columns={this.columns} listRequest={this.state.listRequest}
                                     onAction={this.onAction.bind(this)} actions={this.actions}/>
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/view/product/ProductListView.tsx